

export const RET = (
    <div>
        <p>
            <p className="title"><b>Research Experience for Teachers (RET)</b></p>
            <b className="programs-span">2024 - SDNI Summer Nano-SUIT Program for Community College Teachers</b>
            <br/><br/>
            <b className="programs-span">About the program:</b>
            <br/><br/>
            <b className="programs-span">Research Experience for Teachers (RET)</b>
            <br/><br/>
            RET teachers receive hands-on nanotechnology research experience in a UCSD Faculty lab for a period of 6-8
            weeks. At the end of the program, participants produce a lesson plan, based on their research experience or
            another nanotechnology topic of their choice, that they must bring back to their respective schools/colleges
            for implementation in their class as well as sharing with their peers. This program hence acts as a catalyst
            for the “The California NanoTech 2025 Project”, which ultimately aims to integrate nanotechnology contents
            with the current college science curricula/programs across California. Please take note that each
            participant will be matched with an appropriate SDNI professor-mentor for the entire 6 weeks of the program,
            and the seminars will be provided by Dr. Yves Theriault, SDNI Director of Education Programs and Outreach.
            <br/><br/>
            <b className="programs-span">Dates:</b> Starts June 24, 2024 or as agreed with Yves Theriault.
            <br/><br/>
            <b className="programs-span">Duration:</b> 6 weeks (possibility to extend to 8 weeks)
            <br/><br/>
            <b className="programs-span">Eligibility:</b> Must be an active Community College Teacher, recommended by 1
            recommender, and must be able to commit to the entire 6 weeks program. In addition, applicants must be
            United States citizens or U.S. permanent residents.
            <br/><br/>
            <b className="programs-span">Housing:</b> Not provided for Nano-SUIT participants
            <br/><br/>
            <b className="programs-span">Travel Expenses:</b> Not provided for Nano-SUIT participants
            <br/><br/>
            <b className="programs-span">Stipends:</b> Participants will receive a $6,000 stipend in addition to a
            $1,000 materials budget.
            <br/><br/>
            <b className="programs-span">To apply, please email Yves Theriault at <a
                href={"mailto:ytheriault@ucsd.edu"}>ytheriault@ucsd.edu</a> with the following information:
                <li>Full Name</li>
                <li>Email Address</li>
                <li>Name of Community College</li>
                <li>Subject Taught</li>
                <li>Cell Phone Number (optional, but helpful)</li>
            </b>
            <br/>
            <br/>
        </p>
    </div>
)
